module.exports = __webpack_public_path__ + "img/pr-10.bfe2df18.png";